import {endpoint} from 'services/Api';
import {RESOURCE as PARENT} from 'services/api/dashboards';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'executive';

/**
 * Executive Dashboard Endpoints:
 *     - overview
 */
export default {
    /**
     * Average Reserves By Disease
     *
     * @return {Promise}
     */
    averageReserves: filters => endpoint(`${PARENT}/${RESOURCE}`, 'averageReserves', {
        chartType: 'averageReserves',
        ...filters
    }),


    /**
     * Total Reserves By Disease
     *
     * @return {Promise}
     */
    totalReserves: filters => endpoint(`${PARENT}/${RESOURCE}`, 'totalReserves', {
        chartType: 'totalReserves',
        ...filters
    }),

    /**
     * Trends In Reserve
     *
     * @return {Promise}
     */
    trendsInReserves: filters => endpoint(`${PARENT}/${RESOURCE}`, 'trendsInReserves', {
        chartType: 'trendsInReserves',
        ...filters
    }),
};



// WEBPACK FOOTER //
// ./src/services/api/dashboards/executive.js